module.exports = __webpack_public_path__ + "static/media/overseas.f907cb6b.png";